import { Warnings } from '@/components/Pages/ocr/components/warnings'
import { Dialog } from '@/components/UI/Dialog'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

type OcrWarning = {
  title: string | null
  content: string | null
}

type Props = {
  /** ダイアログが開いているか */
  opened: boolean
  /** API から取得した OCR 注意喚起データ */
  ocrWarning?: OcrWarning | null
  /** 「次へ進む」押下時のコールバック（省略時はボタン非表示） */
  onConfirm?: () => void
  /** 「もどる」または閉じるボタン押下時のコールバック */
  onClose: () => void
}

/**
 * OCR 注意喚起ダイアログ
 * スポット詳細画面の上にオーバーレイ表示する。
 */
export const DialogOcrWarning = memo(({ opened, ocrWarning, onConfirm, onClose }: Props) => {
  const { t } = useTranslation()
  const dialogTitle = ocrWarning?.title ?? t('ocr.warning.title', 'レシート読み取りの注意点')

  return (
    <Dialog
      selectorState={opened}
      title={dialogTitle}
      showCloseButton={true}
      lockScroll={true}
      closeAction={onClose}
      closeOnClickOutside={false}
    >
      <Warnings ocrWarning={ocrWarning} onConfirm={onConfirm} onBack={onClose} />
    </Dialog>
  )
})

DialogOcrWarning.displayName = 'DialogOcrWarning'
